'use client'

import Navbar from '@/components/home/Navbar'
import { useIsMobile } from '@/hooks/use-mobile'

export default function BlogNavbar() {
  const isMobile = useIsMobile()
  return <Navbar isMobile={isMobile} isHomePage={false} />
}
